import * as types from './types';
import { ReportService } from '../../services/report.service';

export const accountingReportActions = {
  async [types.ReportData.FETCH.ALL]({ commit }) {
    const reportData = await ReportService.findReportData();
    commit(types.ReportData.SET.ALL, reportData.data);
  },
  async [types.ReportData.UPDATE.ALL]({ commit }, { reportData }) {
    commit(types.ReportData.SET.ALL, reportData);
  }
}